import { render, staticRenderFns } from "./FrequentlyQuestions.vue?vue&type=template&id=381e58fe&"
import script from "./FrequentlyQuestions.vue?vue&type=script&lang=js&"
export * from "./FrequentlyQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports